import { useState, useCallback } from 'react';
import { adminAPI } from '../services/api';

interface UserDependencies {
  user_id: number;
  user_email: string;
  user_name: string;
  order_count: number;
  vehicle_count: number;
  wallet_balance: number;
  can_delete: boolean;
  blocking_reasons: string[];
}

interface UseUserDeletionImpactReturn {
  dependencies: UserDependencies | null;
  loading: boolean;
  error: string | null;
  fetchDependencies: (userId: number) => Promise<void>;
  reset: () => void;
}

export function useUserDeletionImpact(): UseUserDeletionImpactReturn {
  const [dependencies, setDependencies] = useState<UserDependencies | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchDependencies = useCallback(async (userId: number) => {
    setLoading(true);
    setError(null);
    try {
      const data = await adminAPI.getUserDependencies(userId);
      setDependencies(data);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Failed to fetch user dependencies');
      setDependencies(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setDependencies(null);
    setError(null);
    setLoading(false);
  }, []);

  return {
    dependencies,
    loading,
    error,
    fetchDependencies,
    reset,
  };
}
